import ApplyButton from "components/ApplyNow/ApplyButton";
import { t } from "i18next";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

export default function Note({
  title = t("applyTabCongratsTitle"),
  description = t("applyTabCongratsDescription"),
  description2,
  buttonText,
  onClick,
  className,
  ...props
}) {
  const { dir } = useAppSelector(getSettings);
  return (
    <>
      <div className="flex flex-col max-w-max md:max-w-xl w-full mx-auto my-4 lg:my-20 px-5 lg:px-0" dir={dir}>
        <h2 className="font-bold text-3xl text-theme-blue text-center">
          {title}
        </h2>
        <p className="text-theme-blue text-lg text-center mt-10"
        dangerouslySetInnerHTML={{
          __html: description
        }}
        >
        </p>
        {description2 && (
          <p className="text-theme-blue text-lg text-center mt-10">
            {description2}
          </p>
        )}
        <ApplyButton
          className="mt-14 w-full md:w-72 mx-auto"
          text={buttonText}
          onClick={onClick}
        />
      </div>
    </>
  );
}
